// extracted by mini-css-extract-plugin
export default {"overlay":"ProductDetailModal_overlay__jHi7k","content":"ProductDetailModal_content__RDjlb","close":"ProductDetailModal_close__qgrqV"};